import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Briefcase, CreditCard, Award, Plane, ShieldCheck, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

const CAPABILITY_ITEMS = [
  { key: 'has_fee_waiver',           label: 'Fee waiver logic',         hint: 'Show spend-based renewal-fee-waiver fields',        icon: ShieldCheck },
  { key: 'has_lounge_access',        label: 'Lounge access',            hint: 'Show domestic / international lounge counts',       icon: Plane },
  { key: 'supports_transfer_partners','label': 'Transfer partners',     hint: 'Show airline / hotel mileage transfer mappings',    icon: Sparkles },
  { key: 'has_milestones',           label: 'Milestone bonuses',        hint: 'Show spend-target milestones (₹4L, ₹7.5L, etc.)',   icon: Award },
  { key: 'supports_portal_accelerators',label: 'Portal accelerators',   hint: 'SmartBuy / Travel EDGE / GYFTR routing rules',      icon: CreditCard },
  { key: 'is_business_card',         label: 'Business / Commercial',    hint: 'Different MCC overlap and reward structures apply', icon: Briefcase },
];

const DEFAULT_CAPABILITIES = {
  has_fee_waiver: false,
  has_lounge_access: false,
  supports_transfer_partners: false,
  has_milestones: false,
  supports_portal_accelerators: false,
  is_business_card: false,
};

export const CapabilityToggles = ({ value, onChange, disabled, className, compact = false }) => {
  const caps = value || DEFAULT_CAPABILITIES;
  return (
    <div className={cn('grid gap-2', compact ? 'grid-cols-2' : 'grid-cols-1 sm:grid-cols-2', className)} data-testid="admin-capability-toggles">
      {CAPABILITY_ITEMS.map(({ key, label, hint, icon: Icon }) => (
        <label
          key={key}
          className={cn(
            'flex items-center gap-3 rounded-lg border border-border bg-[hsl(var(--surface-2))] px-3 py-2.5 cursor-pointer transition-colors',
            caps[key] ? 'border-accent/40 bg-accent/5' : 'hover:border-foreground/15',
          )}
          data-testid={`admin-capability-toggle-${key}`}
        >
          <div className={cn('h-7 w-7 rounded-md grid place-items-center shrink-0', caps[key] ? 'bg-accent/10 text-accent' : 'bg-background text-muted-foreground')}>
            <Icon className="h-3.5 w-3.5" />
          </div>
          <div className="flex-1 min-w-0">
            <Label className="text-xs font-medium cursor-pointer">{label}</Label>
            {!compact && <div className="text-[10px] text-muted-foreground leading-tight">{hint}</div>}
          </div>
          <Switch checked={!!caps[key]} onCheckedChange={(v) => onChange?.({ ...caps, [key]: v })} disabled={disabled} />
        </label>
      ))}
    </div>
  );
};

export const DEFAULT_CARD_CAPABILITIES = DEFAULT_CAPABILITIES;
